/**
 * @generated SignedSource<<c7d9fbf0f9f046553e76513425ceaca8>>
 * @relayHash fecf54055e7ebdf24f46943683e10daa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterDeleteInput = {
  helpCenterAri: string;
};
export type useHelpCenterDeleteMutation$variables = {
  cloudId: string;
  input: HelpCenterDeleteInput;
};
export type useHelpCenterDeleteMutation$data = {
  readonly helpCenter: {
    readonly deleteHelpCenter: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type useHelpCenterDeleteMutation = {
  response: useHelpCenterDeleteMutation$data;
  variables: useHelpCenterDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterDeletePayload",
        "kind": "LinkedField",
        "name": "deleteHelpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHelpCenterDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHelpCenterDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8",
    "metadata": {},
    "name": "useHelpCenterDeleteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7f1dd80d488ff1c4273819ebc7261544";

export default node;
